import { put, select, takeLatest } from "redux-saga/effects";
import {
  createStaffAdminFailure,
  createStaffAdminStart,
  createStaffAdminSuccess,
  deleteStaffFailure,
  deleteStaffStart,
  deleteStaffSuccess,
  getAdminDetailsFailure,
  getAdminDetailsStart,
  getAdminDetailsSuccess,
  getAdminsListFailure,
  getAdminsListStart,
  getAdminsListSuccess,
  getAllStaffFailure,
  getAllStaffStart,
  getAllStaffSuccess,
  getStaffGroupsFailure,
  getStaffGroupsStart,
  getStaffGroupsSuccess,
  updateStaffAdminFailure,
  updateStaffAdminStart,
  updateStaffAdminSuccess,
  updateStaffStatusFailure,
  updateStaffStatusStart,
  updateStaffStatusSuccess,
  verifyStaffVerificationCodeFailure,
  verifyStaffVerificationCodeStart,
  verifyStaffVerificationCodeSuccess,
} from "../redux-slices/staffSlice";
import { createStaff, deleteStaff, getAllGroups, getAllStaff, getStaffById, getStaffDetails, updateStaff, updateStaffStatus, verifyStaffCode } from "../../utils/apiCalls";
import { toast } from "../../components/Toast";
import { AdminsRoutes } from "../../routes";
import { setItem, setLoginToken } from "../../utils/storageUtils";

export default function* staffWatcher() {
  yield takeLatest(createStaffAdminStart.type, createStaffWorker);
  yield takeLatest(getAllStaffStart.type, getAllStaffWorker);
  yield takeLatest(getStaffGroupsStart.type, getStaffGroupsWorker);
  yield takeLatest(updateStaffAdminStart.type, updateStaffWorker);
  yield takeLatest(getAdminDetailsStart.type, getStaffDetailsWorker);
  yield takeLatest(getAdminsListStart.type, getStaffByIdWorker);
  yield takeLatest(deleteStaffStart.type, deleteStaffWorker);
  yield takeLatest(updateStaffStatusStart.type, updateStaffStatusWorker);
  yield takeLatest(verifyStaffVerificationCodeStart.type, verifyStaffVerificationCodeWorker);
}

function* getAllStaffWorker(action) {
  try {
    const { pageNo, limit, orderBy, sort, search , roleId, status} = action && action.payload;
    const res = yield getAllStaff({ pageNo, limit, orderBy, sort, search: search || '' , roleId: roleId || "" , status: status || ""});

    yield put(getAllStaffSuccess(res?.data?.data?.data));
  } catch (e) {
    yield put(getAllStaffFailure());

    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* getStaffDetailsWorker(action) {
  try {
    const res = yield getStaffDetails(action.payload);

    yield put(getAdminDetailsSuccess(res?.data?.data?.adminUser));
  } catch (e) {
    yield put(getAdminDetailsFailure());
    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* getStaffByIdWorker(action) {
  try {
    const { pageNo, limit, roleId } = action && action.payload;

    const res = yield getStaffById({ pageNo, limit, roleId });

    yield put(getAdminsListSuccess(res?.data?.data?.result?.adminUsers));
  } catch (e) {
    yield put(getAdminsListFailure())
    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* createStaffWorker(action) {
  try {
    const { data, navigate } = action && action.payload;

    yield createStaff(data);

    yield put(createStaffAdminSuccess());

    yield toast(`${data?.profile?.role} staff created`, "success");

    navigate(AdminsRoutes.Staff);
  } catch (e) {
    yield put(createStaffAdminFailure());

    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* updateStaffWorker(action) {
  try {
    const { data, onSuccess } = action && action.payload;

    yield updateStaff(data);

    yield put(updateStaffAdminSuccess());

    yield toast(`${data?.role} staff updated`, "success");

    if (onSuccess) {
      yield onSuccess();
    }
  } catch (e) {
    yield put(updateStaffAdminFailure());

    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* deleteStaffWorker(action) {
  const { data, onSuccess, onError } = action && action.payload;

  try {
    yield deleteStaff(data);

    yield put(deleteStaffSuccess());

    if (onSuccess) {
      yield onSuccess();
    }
  } catch (e) {
    yield put(deleteStaffFailure());

    if (onError) {
      onError(e?.response?.data?.errors[0]?.description)
    } else {
      yield toast(e?.response?.data?.errors[0]?.description, "error");
    }
  }
}

function* updateStaffStatusWorker(action) {
  const { data, onSuccess, onError } = action && action.payload;

  try {
    yield updateStaffStatus(data);

    yield put(updateStaffStatusSuccess());

    if (onSuccess) {
      yield onSuccess();
    }
  } catch (e) {
    yield put(updateStaffStatusFailure());

    if (onError) {
      onError(e?.response?.data?.errors[0]?.description)
    } else {
      yield toast(e?.response?.data?.errors[0]?.description, "error");
    }
  }
}

function* getStaffGroupsWorker(action) {
  try {
    const result = yield getAllGroups();

    yield put(getStaffGroupsSuccess(result?.data?.data?.groupNames));
  } catch (e) {
    yield put(getStaffGroupsFailure());

    yield toast(e?.response?.data?.errors[0]?.description, "error");
  }
}

function* verifyStaffVerificationCodeWorker(action) {
  const { data, onSuccess, onError, completeLogin } = action && action.payload;

  try {
    // yield verifyStaffCode(data);

    const response = yield verifyStaffCode(data);

    // If this is part of login flow, complete the login
    if (response?.data?.data?.successful) {
      const { tempAccessToken, role , } = yield select(state => state.login);

      if (tempAccessToken) {
        setLoginToken(tempAccessToken);
        setItem('role', role);
      }

      if (onSuccess) {
        yield onSuccess();
      }
  
      yield put(verifyStaffVerificationCodeSuccess());

    }
    else {
      onError(response?.data?.data?.serviceErrors?.message ||     response?.data?.data?.errors[0]?.description  )
      yield put(verifyStaffVerificationCodeFailure());
    }

    
  }
  catch (e) {
    onError(e?.response?.data?.errors[0]?.description)

    yield put(verifyStaffVerificationCodeFailure());
  }
}
